export const HYBRID_REFRESH_V1 = process.env.REACT_APP_HYBRID_REFRESH_V1 !== 'false';

export function getHybridIntervalMs(activeMs = 60000) {
  if (!HYBRID_REFRESH_V1) return activeMs;
  const isVisible = typeof document !== 'undefined' ? document.visibilityState === 'visible' : true;
  if (isVisible) return activeMs;
  if (activeMs <= 30000) return 120000;
  if (activeMs <= 60000) return 300000;
  return Math.max(activeMs, 300000);
}

export function startHybridPolling(fn, activeMs = 60000) {
  let timer = null;
  let cancelled = false;

  const schedule = () => {
    if (cancelled) return;
    const delay = getHybridIntervalMs(activeMs);
    timer = setTimeout(async () => {
      try {
        if (!cancelled) await fn();
      } finally {
        schedule();
      }
    }, delay);
  };

  const onVisibility = () => {
    if (timer) clearTimeout(timer);
    schedule();
  };

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onVisibility);
  }
  schedule();

  return () => {
    cancelled = true;
    if (timer) clearTimeout(timer);
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', onVisibility);
    }
  };
}
